import withShadow from './withShadow';

export default withShadow;
